import { CardsHeartIcon } from './CardsHeartIcon';

/**
 * author: Nick
 * id 152E7662-6FDD-478C-A945-68F6B04CB073
 * name cards-heart
 * version: 2.3.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cards-heart.svg
 * tags
 * - Gaming / RPG 
 */
export const SuitHeartsIcon = CardsHeartIcon;
export default SuitHeartsIcon